var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.5V4.83333C9.66671 5.05435 9.7545 5.26631 9.91078 5.42259C10.0671 5.57887 10.279 5.66667 10.5 5.66667H13.8334M9.66671 1.5H3.83337C3.39135 1.5 2.96742 1.67559 2.65486 1.98816C2.3423 2.30072 2.16671 2.72464 2.16671 3.16667V9M9.66671 1.5L13.8334 5.66667M13.8334 5.66667V9M1.33337 11.5L4.66671 16.5M1.33337 16.5L4.66671 11.5M12.1667 15.875C12.1667 16.22 12.4467 16.5 12.7917 16.5H13.8334C14.0544 16.5 14.2664 16.4122 14.4226 16.2559C14.5789 16.0996 14.6667 15.8877 14.6667 15.6667V14.8333C14.6667 14.6123 14.5789 14.4004 14.4226 14.2441C14.2664 14.0878 14.0544 14 13.8334 14H13C12.779 14 12.5671 13.9122 12.4108 13.7559C12.2545 13.5996 12.1667 13.3877 12.1667 13.1667V12.3333C12.1667 12.1123 12.2545 11.9004 12.4108 11.7441C12.5671 11.5878 12.779 11.5 13 11.5H14.0417C14.2075 11.5 14.3664 11.5658 14.4836 11.6831C14.6009 11.8003 14.6667 11.9592 14.6667 12.125M7.16671 11.5V16.5H9.66671",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls-icon.de7a774924eaf25e0b6b810e046532f0.svg";
export { ForwardRef as ReactComponent };